<span class="-pill -fontMedium -canclick">
  <span *ngIf="icon">
    <img [src]="'assets/images/country-icons/'+icon+'.svg'" [alt]="icon"/>
  </span>
  <!-- <icon *ngIf="icon" [icon]="icon" class="-colorShadePrimaryBlackS20"></icon> -->
  <ng-container *ngTemplateOutlet="content"></ng-container>
</span>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
